// export constants that we use in the rest of the program to avoid working with strings.
export const setChannelsQuery = "setChannelsQuery"
export const setChannelsRoFQuery = "setChannelsRoFQuery"
export const setChannelsQueryForApi = "setChannelsQueryForApi"
export const setChannelsExportQuery = "setChannelsExportQuery"
export const setChannelsQueryProviders = "setChannelsQueryProviders"
export const setChannelsResults = "setChannelsResults"
export const setChannelsRoFResults = "setChannelsRoFResults"
export const setChannelsRoFResultsTableData = "setChannelsRoFResultsTableData"
export const setChannelsHaveSelectedRow = "setChannelsHaveSelectedRow"
export const setChannelsColumnTypes = "setChannelsColumnTypes"
export const setChannelsInitStatus = "setChannelsInitStatus"
export const setChannelsStartdate = "setChannelsStartdate"
export const setChannelsEnddate = "setChannelsEnddate"
export const setChannelsDefaultColumns = "setChannelsDefaultColumns"
export const setChannelsProviders = "setChannelsProviders"
export const setChannelsSelectedChannelInfo = "setChannelsSelectedChannelInfo"
export const setQueryCostData = "setChannelsQueryCostData"
export const setQueryCostLoading = "setChannelsQueryCostLoading"
export const setQueryCostError = "setChannelsQueryCostError"
export const setChannelsQueryBeforeChange = "setChannelsQueryBeforeChange"
export const setChannelsStringForFilterBeforeChange = "setChannelsStringForFilterBeforeChange"
export const setChannelsHasExcludedRow = "setChannelsHasExcludedRow"
export const setChannelsExcludedRows = "setChannelsExcludedRows"
export const setChannelsQueryDefault = "setChannelsQueryDefault"
export const setChannelsHasSetDefaultQuery = "setChannelsHasSetDefaultQuery"
export const setChannelsSumVisible = "setChannelsSumVisible"

